import { message } from 'ant-design-vue'
import {
  postPayloadAuth,
  postPayloadCommands,
  PayloadCommandsEnum,
  PostCameraModeBody,
  PostCameraFocalLengthBody,
  PostGimbalResetBody,
  PostCameraAimBody,
  PostCameraCrameZoomBody,
  PostCameraScreenDragBody,
  PostCameraScreenSplitBody,
  PostCameraPointFocusActionBody,
  PostCameraLookAtBody,
  PostIrMeteringModeSetBody,
  PostIrMeteringPointSetBody,
  PostIrMeteringAreaSetBody,
} from '/@/api/drone-control/payload'
import { ControlSource } from '/@/types/device'

export function usePayloadControl () {
  function checkPayloadAuth (controlSource?: ControlSource) {
    if (controlSource !== ControlSource.A) {
      message.error('首先获取有效载荷')
      return false
    }
    return true
  }

  async function authPayload (sn: string, payloadIndx: string) {
    const { code } = await postPayloadAuth(sn, {
      payload_index: payloadIndx
    })
    if (code === 0) {
      message.success('获取有效载荷控制成功')
      return true
    }
    return false
  }

  // 看向目标点,lookat 功能指飞行器将从当前朝向转向实际经纬高度指定的点，在 M30/M30T 机型上建议使用锁定机头的方式，仅云台转动场景下在抵达云台限位角后 lookat 功能将出现异常
  async function cameraLookAt (sn: string, data: PostCameraLookAtBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraLookAt,
      data: data
    })
    if (code === 0) {
      // message.success('看向目标点成功')
    }
  }

  // 点对焦
  async function cameraPointFocusAction (sn: string, data: PostCameraPointFocusActionBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraPointFocusAction,
      data: data
    })
    if (code === 0) {
      message.success('点对焦成功')
    }
  }

  // 分屏控制
  async function cameraScreenSplit (sn: string, data: PostCameraScreenSplitBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraScreenSplit,
      data: data
    })
    if (code === 0) {
      message.success('分屏控制成功')
    }
  }

  // 云台重置
  async function resetGimbal (sn: string, data: PostGimbalResetBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.GimbalReset,
      data: data
    })
    if (code === 0) {
      message.success('云台重置成功')
    }
  }

  // 框选变焦功能为在相机镜头的视野范围内，框选镜头中的目标区域，将会自动把画面切过去自动变焦+转云台
  async function cameraCrameZoom (sn: string, data: PostCameraCrameZoomBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraCrameZoom,
      data: data
    })
    if (code === 0) {
      message.success('框选变焦成功')
    }
  }

  // 画面拖动控制
  async function cameraScreenDrag (sn: string, data: PostCameraScreenDragBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraScreenDrag,
      data: data
    })
    if (code === 0) {
      message.success('框选变焦成功')
    }
  }

  async function switchCameraMode (sn: string, data: PostCameraModeBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraModeSwitch,
      data: data
    })
    // if (code === 0) {
    //   message.success('相机模式切换成功,当前模式为:' + data.camera_mode)
    // }
  }

  // 开始拍照
  async function takeCameraPhoto (sn: string, payloadIndx: string) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraPhotoTake,
      data: {
        payload_index: payloadIndx
      }
    })
    if (code === 0) {
      message.success('拍照成功')
    }
  }

  // 停止拍照(停止拍照指令，目前仅支持全景拍照模式)
  async function takeCameraPhotoStop (sn: string, payloadIndx: string) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraPhotoStop,
      data: {
        payload_index: payloadIndx
      }
    })
    if (code === 0) {
      message.success('停止拍照成功')
    }
  }

  async function startCameraRecording (sn: string, payloadIndx: string) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraRecordingStart,
      data: {
        payload_index: payloadIndx
      }
    })
    if (code === 0) {
      message.success('开始录制成功')
    }
  }

  async function stopCameraRecording (sn: string, payloadIndx: string) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraRecordingStop,
      data: {
        payload_index: payloadIndx
      }
    })
    if (code === 0) {
      message.success('停止录制成功')
    }
  }

  async function changeCameraFocalLength (sn: string, data: PostCameraFocalLengthBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraFocalLengthSet,
      data: data,
    })
    if (code === 0) {
      console.log('变焦成功')
    }
  }

  async function cameraAim (sn: string, data: PostCameraAimBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.CameraAim,
      data: data,
    })
    if (code === 0) {
      console.log('聚焦成功')
    }
  }

  /** 红外测温模式设置 */
  async function changeIrModeSet (sn:string, data:PostIrMeteringModeSetBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.IrMeteringModeSet,
      data: data
    })
    if (code === 0) {
      console.log('红外测距模式设置成功')
    }
  }

  /** 红外点测温 */
  async function irPointMetring (sn:string, data:PostIrMeteringPointSetBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.IrMeteringPointSet,
      data: data
    })
    if (code === 0) {
      console.log('红外测温点设置成功')
    }
  }

  /** 红外区域测温 */
  async function irAreaMetring (sn:string, data:PostIrMeteringAreaSetBody) {
    const { code } = await postPayloadCommands(sn, {
      cmd: PayloadCommandsEnum.IrMeteringAreaSet,
      data: data
    })
    if (code === 0) {
      console.log('红外测温区域设置成功')
    }
  }

  return {
    checkPayloadAuth,
    authPayload,
    resetGimbal,
    switchCameraMode,
    takeCameraPhoto,
    startCameraRecording,
    stopCameraRecording,
    changeCameraFocalLength,
    cameraAim,
    cameraCrameZoom,
    cameraScreenDrag,
    takeCameraPhotoStop,
    cameraScreenSplit,
    cameraPointFocusAction,
    cameraLookAt,
    changeIrModeSet,
    irPointMetring,
    irAreaMetring
  }
}
